import type { FC, RefObject } from 'react'
import { createContext, useContext } from 'react'

export interface TreeViewContextValue {
  expandedItems: string[]
  selectedItems: string | string[]
  focusedItemId: string | null
  treeRootRef: RefObject<HTMLUListElement | null>
  onItemExpansionToggle?: (ev: unknown, itemId: string) => void
  onItemSelectionToggle?: (ev: unknown, itemId: string) => void
  onSelectedItemsChange?: (ev: unknown, itemId: string | null) => void
  CollapseIcon?: FC
  ExpandIcon?: FC
}

export const TreeViewContext = createContext<TreeViewContextValue>({
  expandedItems: [],
  selectedItems: '',
  focusedItemId: null,
  treeRootRef: { current: null },
})

export const useTreeViewContext = () => useContext(TreeViewContext)
